export default __webpack_public_path__ + "static/media/previous.a5f1a66d.svg";